const BASE_URL = '/backend-api';
const WS_BASE_URL = BASE_URL.replace(/^http(s)?:\/\//, 'wss://');

export const environment = {
  BASE_URL,
  THEME: 'aura-light-noir.css',
  CLEARING_API_ENDPOINT: `${BASE_URL!}/partner-api/v1`,
  CLEARING_CUSTOM_API_ENDPOINT: `${BASE_URL!}/clearing-api/v1`,
  MESSAGE_BROKER_URL: `${WS_BASE_URL}/ws`,
  LIGHT_PARTNER_API_PATH: '/light',
  SEARCH_ENDPOINT: `${BASE_URL!}/search`,
  PARTNERSHIP_APP_URL:
    'https://cp-gui-oxgg.cp-test-2.dev.bitconex.com/partnership/',
  ITU_CODE: 'DEU.OXGG',
  OWNER_SUB_ENTITIES: [],
  KEYCLOAK: {
    URL: 'https://keycloak.cp-test-2.dev.bitconex.com',
    REALM: 'clearing-realm-oxgg',
    CLIENT_ID: 'clearing-gui-client',
    REDIRECT_URI: 'https://cp-gui-oxgg.cp-test-2.dev.bitconex.com/',
  },
};
